<template>
  <v-layout>
    <v-dialog v-model="show" max-width="800px" lazy>
      <v-card>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click.stop="show=false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Mutton Buster</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.name"
                  @keyup.enter="save"
                  label="Rider Name"
                  ref="focusName"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.address"
                  @keyup.enter="save"
                  label="Address"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs10 md5>
                    <v-text-field
                      v-model="editedItem.city"
                      @keyup.enter="save"
                      label="City"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 md2>
                    <v-text-field
                      v-model="editedItem.state"
                      @keyup.enter="save"
                      label="ST"
                      mask="AA"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="editedItem.zip"
                      @keyup.enter="save"
                      label="Zipcode"
                      mask="#####"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.cellPhone"
                  @keyup.enter="save"
                  label="Mobile"
                  mask="(###) ###-####"
                  return-masked-value
                  prepend-icon="stay_current_portrait"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.homePhone"
                  @:keyup.enter="save"
                  label="Home"
                  mask="(###) ###-####"
                  return-masked-value
                  prepend-icon="phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.email"
                  @keyup.enter="save"
                  label="Email Address"
                  prepend-icon="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="editedItem.age"
                  @keyup.enter="save"
                  label="Age"
                  mask="#"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="editedItem.weight"
                  @keyup.enter="save"
                  label="Weight"
                  mask="##"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formattedDate"
                    label="Birth Date"
                    prepend-icon="cake"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="editedItem.birthDate"
                    no-title
                    @input="menu1 = false"
                    @change="formattedDate = formatDate(editedItem.birthDate)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.other"
                  @keyup.enter="save"
                  label="Other Mutton Busters"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.parents"
                  @keyup.enter="save"
                  label="Parent or Legal Guardian"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="editedItem.night"
                  :items="dates"
                  item-text="date"
                  item-value="night"
                  label="Select Night"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.sheep"
                  @keyup.enter="save"
                  label="Sheep Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red darken-1"
            flat
            @click.native="deleteItem"
          >Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            v-if="saving"
            @click.stop="show=false"
          >Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            transition="fade-transition"
            v-if="!saving"
            flat
            @click.stop="show=false"
          >Close</v-btn>
          <v-btn
            color="blue darken-1"
            dark
            transition="fade-transition"
            v-if="saving"
            @click.native="save"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import moment from 'moment'

export default {
  props: ['visible', 'item'],

  data () {
    return {
      menu1: false,
      currentYear: 0,
      formattedDate: '',
      saving: false,
      showpassword: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      activeTab: '',
      statuses: [
        { text: 'Inactive', value: 'inactive' },
        { text: 'Active', value: 'active' }
      ],
      handBooks: [
        { text: 'No', value: false },
        { text: 'Yes', value: true }
      ],
      croppa: {},
      initialImage: null,
      editedItem: this.item,
      titleName: '',
      dates: []
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name
    this.currentYear = this.$store.state.currentYear

    this.getDates()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        console.log('test')
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        console.log('test')
        this.saving = true
      },
      deep: true
    }
  },

  methods: {
    loadItem () {
      this.editedItem = this.item

      this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
    },

    async getDates () {
      this.isCommChair = false

      try {
        const response = await Api().get('get_bustin_dates/' + this.currentYear)

        const busterList = response.data

        const busters = []

        for (let i in busterList) {
          busterList[i].date = moment(String(busterList[i].date)).format('MM/DD/YYYY')
          busters.push(busterList)
        }

        this.dates = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    async save () {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)

      try {
        const response = await Api().put('update_profile/' + this.editedItem.id, this.editedItem)
        this.$store.dispatch('setUser', this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mbChampionship/InternalForm.vue